import { render } from "./ReportDisplayField.vue?vue&type=template&id=509bf698&scoped=true"
import script from "./ReportDisplayField.vue?vue&type=script&lang=js"
export * from "./ReportDisplayField.vue?vue&type=script&lang=js"

import "./ReportDisplayField.vue?vue&type=style&index=0&id=509bf698&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509bf698"]])

export default __exports__